/**
 * @fileoverview Australian state/territory codes for address inputs.
 *
 * Used by contact address editors and the InfoTrack manual-search composer.
 */

export interface AuStateOption {
  value: string;
  label: string;
}

export const AU_STATES: ReadonlyArray<AuStateOption> = [
  { value: "NSW", label: "NSW" },
  { value: "VIC", label: "VIC" },
  { value: "QLD", label: "QLD" },
  { value: "SA", label: "SA" },
  { value: "WA", label: "WA" },
  { value: "TAS", label: "TAS" },
  { value: "NT", label: "NT" },
  { value: "ACT", label: "ACT" },
];

export const AU_STATE_VALUES = AU_STATES.map((s) => s.value);
